import {BaseService} from './BaseService';

import {ObjectUtils} from "../../Utils";

export class BaseSearchableService extends BaseService {
    constructor() {
        super();

        this.cachedValue = {};
    }

    get Request() {
        return {limit: 20};
    }

    isCached(id) {
        return this.cachedValue[id] !== undefined;
    }

    FlushCache() {
        this.cachedValue = {};
    }

    Get(modelId = null, useCache = true) {
        if(modelId) {
           return this.FindById(modelId, useCache); 
        }
        return this.SendRequest(BaseService.GET, this.Request);
    }

    GetWithContext(context) {
        return this.SendRequest(BaseSearchableService.GET, context);
    }

    Search(name = null, additionalParams) {
        return this.SendRequest(BaseService.GET, { name, ...additionalParams, ...this.Request});
    }
    
    SearchWithContext(name, context, additionalParams) {
        return this.SendRequest(BaseService.GET, { name, ...context, ...additionalParams, ...this.Request});
    }
    
    _getQueueInterval = 100;
    _getRequestTimer = null;
    _queuedGetRequests = {};
    QueueGetRequest(id) {
        // this promise defers resolving until
        // our timeout fires and we resolve all the
        // get methods at the same time.
        const promise = new Promise((resolve, reject) => {
            this._queuedGetRequests[id] ??= [];
            this._queuedGetRequests[id].push([resolve, reject]);
        });

        clearTimeout(this._getRequestTimer);
        this._getRequestTimer = setTimeout(async () => {
            // store the queue in a local variable
            const getRequests = this._queuedGetRequests;
            // clear the queue so it can be added to again
            this._queuedGetRequests = {};
            
            const modelIds = Object.keys(getRequests);
            const postData = (modelIds.length === 1) ? modelIds[0] : {[this.PrimaryKeyPropertyPlural]: modelIds.join(","), ...this.Request}

            try {
                const response = await this.SendRequest(BaseService.GET, postData);

                const {result = []} = response;
                for (const [id, getRequest] of Object.entries(getRequests)) {
                    
                    // this line standardizes the response from Get and GetAll into arrays
                    const resultArray = Array.isArray(result) ? result : [result];
                    const model = resultArray?.find((r) => Number(r[this.PrimaryKeyProperty]) === Number(id));
                    const singleResponse = {
                        ...response,
                        result: model,
                    }

                    for (const [resolve, _] of getRequest) {
                        resolve(singleResponse);
                    }
                }
            } catch (e) {
                for(const [id, getRequest] of Object.entries(getRequests)) {
                    for (const [_, reject] of getRequest) {
                        reject(e);
                    }
                }
            }
        }, this._getQueueInterval);

        return promise;
    }
    
    TitleById(id, useCache = true) {
        return new Promise(async (resolve, reject) => {
            try {
                const model = (await this.FindById(id, useCache))?.result;
                resolve(model ? this.GetTitle(model) : null);
            } catch (e) {
                reject(e);
            }
        });
    }

    CachedTitleById(id) {
        if(!this.isCached(id)) {
            return null;
        }
        const model = this.cachedValue[id]?.result;
        return model ? this.GetTitle(model) : null;
    }

    FindById(id, useCache = true) {
        if(id == null || id === '') {
            return new Promise((resolve, _) => {
                resolve(null);
            });
        }

        if(useCache && this.isCached(id)) {
            return new Promise((resolve, _) => {
                resolve(this.cachedValue[id]);
            });
        }

        return new Promise((resolve, reject) => {
            // TODO: maybe only use this method on services that
            // have been marked as supporting it
            this.QueueGetRequest(id)
                .then((x) => {
                    this.cachedValue[id] = x;

                    resolve(this.cachedValue[id]);
                })
                .catch((x) => {
                    reject(ObjectUtils.Clone(x));
                })
        });
    }

    Update(model) {
        return this.SendRequest(BaseSearchableService.PUT, model);
    }

    Create(model) {
        return this.SendRequest(BaseSearchableService.POST, model);
    }

    Delete(model) {
        return this.SendRequest(BaseSearchableService.DELETE, model);
    }
}
